import loadingPlaceholder from '@/assets/loading-placeholder.png'
import { legoInit, legoPerf } from '@zz-common/lego'
import '@zz/sasscore/flexible.js'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import { setPicSize } from '@zz-common/zz-utils'
import SentryVueInit from '@zz-common/sentry/lib/sentry-vue-init'
import App from './App.vue'
import router from './router'
import pageIdConfig from '@/libs/pageIdConfig'
import store from './store'

Vue.config.productionTip = false
// Vue.config.errorHandler = (err, vm, info) => {
//   SentryCapture(`全局异常监控：${err} 其他信息：${info}`, 'error')
// }
class __App__ {
  init() {
    tryCatch(() => {
      // 全局初始化乐高埋点的值，默认合入backup
      legoInit(Object.assign({ stayUserTime: true, forbidLegoInPrerender: true }, pageIdConfig))
      legoPerf()
      SentryVueInit() // sentry接入白屏监控，cfg配置在index.html中
    })
    // 懒加载
    this.sueLazyLoad()
    Vue.prototype.$setPicSize = setPicSize
    // 注册vue实例
    this.mount()
  }

  mount() {
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function() {
      Vue.use(VueLazyLoad, {
        preLoad: 1.3,
        try: 2,
        error: loadingPlaceholder,
        loading: loadingPlaceholder
      })
    })
  }
}
const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
